import React from "react";

import PreorderContext from "contexts/PreorderContext";

/**
 * This hook return information related to preorder stored in the PreorderContext context.
 */
const usePreorder = () => React.useContext(PreorderContext);

export default usePreorder;
